export default "__VITE_ASSET__23387e4f__"